// Utilities
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    "__css": ()=>_react["__css"],
    "__resetCSS": ()=>_react["__resetCSS"],
    "__resetStyles": ()=>_react["__resetStyles"],
    "__styles": ()=>_react["__styles"],
    createDOMRenderer: ()=>_react.createDOMRenderer,
    makeResetStyles: ()=>_react.makeResetStyles,
    makeStaticStyles: ()=>_react.makeStaticStyles,
    makeStyles: ()=>_react.makeStyles,
    mergeClasses: ()=>_react.mergeClasses,
    RendererProvider: ()=>_react.RendererProvider,
    renderToStyleElements: ()=>_react.renderToStyleElements,
    shorthands: ()=>_react.shorthands,
    FluentProvider: ()=>_reactProvider.FluentProvider,
    fluentProviderClassNames: ()=>_reactProvider.fluentProviderClassNames,
    renderFluentProvider_unstable: ()=>_reactProvider.renderFluentProvider_unstable,
    useFluentProvider_unstable: ()=>_reactProvider.useFluentProvider_unstable,
    useFluentProviderContextValues_unstable: ()=>_reactProvider.useFluentProviderContextValues_unstable,
    useFluentProviderStyles_unstable: ()=>_reactProvider.useFluentProviderStyles_unstable,
    createCustomFocusIndicatorStyle: ()=>_reactTabster.createCustomFocusIndicatorStyle,
    createFocusOutlineStyle: ()=>_reactTabster.createFocusOutlineStyle,
    useArrowNavigationGroup: ()=>_reactTabster.useArrowNavigationGroup,
    useFocusableGroup: ()=>_reactTabster.useFocusableGroup,
    useFocusFinders: ()=>_reactTabster.useFocusFinders,
    useFocusWithin: ()=>_reactTabster.useFocusWithin,
    useKeyboardNavAttribute: ()=>_reactTabster.useKeyboardNavAttribute,
    useModalAttributes: ()=>_reactTabster.useModalAttributes,
    createDarkTheme: ()=>_reactTheme.createDarkTheme,
    createHighContrastTheme: ()=>_reactTheme.createHighContrastTheme,
    createLightTheme: ()=>_reactTheme.createLightTheme,
    createTeamsDarkTheme: ()=>_reactTheme.createTeamsDarkTheme,
    themeToTokensObject: ()=>_reactTheme.themeToTokensObject,
    teamsDarkTheme: ()=>_reactTheme.teamsDarkTheme,
    teamsHighContrastTheme: ()=>_reactTheme.teamsHighContrastTheme,
    teamsLightTheme: ()=>_reactTheme.teamsLightTheme,
    tokens: ()=>_reactTheme.tokens,
    typographyStyles: ()=>_reactTheme.typographyStyles,
    webDarkTheme: ()=>_reactTheme.webDarkTheme,
    webLightTheme: ()=>_reactTheme.webLightTheme,
    useFluent: ()=>_reactSharedContexts.useFluent_unstable,
    useTooltipVisibility: ()=>_reactSharedContexts.useTooltipVisibility_unstable,
    useThemeClassName: ()=>_reactSharedContexts.useThemeClassName_unstable,
    getNativeElementProps: ()=>_reactUtilities.getNativeElementProps,
    getPartitionedNativeProps: ()=>_reactUtilities.getPartitionedNativeProps,
    getSlots: ()=>_reactUtilities.getSlots,
    IdPrefixProvider: ()=>_reactUtilities.IdPrefixProvider,
    resetIdsForTests: ()=>_reactUtilities.resetIdsForTests,
    resolveShorthand: ()=>_reactUtilities.resolveShorthand,
    SSRProvider: ()=>_reactUtilities.SSRProvider,
    useId: ()=>_reactUtilities.useId,
    useIsomorphicLayoutEffect: ()=>_reactUtilities.useIsomorphicLayoutEffect,
    useIsSSR: ()=>_reactUtilities.useIsSSR,
    useMergedRefs: ()=>_reactUtilities.useMergedRefs,
    useScrollbarWidth: ()=>_reactUtilities.useScrollbarWidth,
    Accordion: ()=>_reactAccordion.Accordion,
    AccordionProvider: ()=>_reactAccordion.AccordionProvider,
    AccordionHeader: ()=>_reactAccordion.AccordionHeader,
    AccordionItem: ()=>_reactAccordion.AccordionItem,
    AccordionItemProvider: ()=>_reactAccordion.AccordionItemProvider,
    AccordionPanel: ()=>_reactAccordion.AccordionPanel,
    accordionClassNames: ()=>_reactAccordion.accordionClassNames,
    accordionHeaderClassNames: ()=>_reactAccordion.accordionHeaderClassNames,
    accordionItemClassNames: ()=>_reactAccordion.accordionItemClassNames,
    accordionPanelClassNames: ()=>_reactAccordion.accordionPanelClassNames,
    renderAccordion_unstable: ()=>_reactAccordion.renderAccordion_unstable,
    renderAccordionHeader_unstable: ()=>_reactAccordion.renderAccordionHeader_unstable,
    renderAccordionItem_unstable: ()=>_reactAccordion.renderAccordionItem_unstable,
    renderAccordionPanel_unstable: ()=>_reactAccordion.renderAccordionPanel_unstable,
    useAccordion_unstable: ()=>_reactAccordion.useAccordion_unstable,
    useAccordionContext_unstable: ()=>_reactAccordion.useAccordionContext_unstable,
    useAccordionContextValues_unstable: ()=>_reactAccordion.useAccordionContextValues_unstable,
    useAccordionHeader_unstable: ()=>_reactAccordion.useAccordionHeader_unstable,
    useAccordionHeaderContextValues_unstable: ()=>_reactAccordion.useAccordionHeaderContextValues_unstable,
    useAccordionHeaderStyles_unstable: ()=>_reactAccordion.useAccordionHeaderStyles_unstable,
    useAccordionItem_unstable: ()=>_reactAccordion.useAccordionItem_unstable,
    useAccordionItemContext_unstable: ()=>_reactAccordion.useAccordionItemContext_unstable,
    useAccordionItemContextValues_unstable: ()=>_reactAccordion.useAccordionItemContextValues_unstable,
    useAccordionItemStyles_unstable: ()=>_reactAccordion.useAccordionItemStyles_unstable,
    useAccordionPanel_unstable: ()=>_reactAccordion.useAccordionPanel_unstable,
    useAccordionPanelStyles_unstable: ()=>_reactAccordion.useAccordionPanelStyles_unstable,
    useAccordionStyles_unstable: ()=>_reactAccordion.useAccordionStyles_unstable,
    Avatar: ()=>_reactAvatar.Avatar,
    avatarClassNames: ()=>_reactAvatar.avatarClassNames,
    renderAvatar_unstable: ()=>_reactAvatar.renderAvatar_unstable,
    useAvatar_unstable: ()=>_reactAvatar.useAvatar_unstable,
    useAvatarStyles_unstable: ()=>_reactAvatar.useAvatarStyles_unstable,
    AvatarGroup: ()=>_reactAvatar.AvatarGroup,
    avatarGroupClassNames: ()=>_reactAvatar.avatarGroupClassNames,
    AvatarGroupItem: ()=>_reactAvatar.AvatarGroupItem,
    avatarGroupItemClassNames: ()=>_reactAvatar.avatarGroupItemClassNames,
    AvatarGroupPopover: ()=>_reactAvatar.AvatarGroupPopover,
    avatarGroupPopoverClassNames: ()=>_reactAvatar.avatarGroupPopoverClassNames,
    AvatarGroupProvider: ()=>_reactAvatar.AvatarGroupProvider,
    renderAvatarGroup_unstable: ()=>_reactAvatar.renderAvatarGroup_unstable,
    useAvatarGroupContextValues: ()=>_reactAvatar.useAvatarGroupContextValues,
    useAvatarGroupStyles_unstable: ()=>_reactAvatar.useAvatarGroupStyles_unstable,
    useAvatarGroup_unstable: ()=>_reactAvatar.useAvatarGroup_unstable,
    renderAvatarGroupItem_unstable: ()=>_reactAvatar.renderAvatarGroupItem_unstable,
    useAvatarGroupItemStyles_unstable: ()=>_reactAvatar.useAvatarGroupItemStyles_unstable,
    useAvatarGroupItem_unstable: ()=>_reactAvatar.useAvatarGroupItem_unstable,
    renderAvatarGroupPopover_unstable: ()=>_reactAvatar.renderAvatarGroupPopover_unstable,
    useAvatarGroupPopoverStyles_unstable: ()=>_reactAvatar.useAvatarGroupPopoverStyles_unstable,
    useAvatarGroupPopover_unstable: ()=>_reactAvatar.useAvatarGroupPopover_unstable,
    useAvatarGroupContext_unstable: ()=>_reactAvatar.useAvatarGroupContext_unstable,
    partitionAvatarGroupItems: ()=>_reactAvatar.partitionAvatarGroupItems,
    Badge: ()=>_reactBadge.Badge,
    CounterBadge: ()=>_reactBadge.CounterBadge,
    PresenceBadge: ()=>_reactBadge.PresenceBadge,
    badgeClassNames: ()=>_reactBadge.badgeClassNames,
    counterBadgeClassNames: ()=>_reactBadge.counterBadgeClassNames,
    presenceBadgeClassNames: ()=>_reactBadge.presenceBadgeClassNames,
    renderBadge_unstable: ()=>_reactBadge.renderBadge_unstable,
    useBadge_unstable: ()=>_reactBadge.useBadge_unstable,
    useBadgeStyles_unstable: ()=>_reactBadge.useBadgeStyles_unstable,
    useCounterBadge_unstable: ()=>_reactBadge.useCounterBadge_unstable,
    useCounterBadgeStyles_unstable: ()=>_reactBadge.useCounterBadgeStyles_unstable,
    usePresenceBadge_unstable: ()=>_reactBadge.usePresenceBadge_unstable,
    usePresenceBadgeStyles_unstable: ()=>_reactBadge.usePresenceBadgeStyles_unstable,
    Button: ()=>_reactButton.Button,
    CompoundButton: ()=>_reactButton.CompoundButton,
    MenuButton: ()=>_reactButton.MenuButton,
    SplitButton: ()=>_reactButton.SplitButton,
    ToggleButton: ()=>_reactButton.ToggleButton,
    buttonClassNames: ()=>_reactButton.buttonClassNames,
    compoundButtonClassNames: ()=>_reactButton.compoundButtonClassNames,
    menuButtonClassNames: ()=>_reactButton.menuButtonClassNames,
    renderButton_unstable: ()=>_reactButton.renderButton_unstable,
    renderCompoundButton_unstable: ()=>_reactButton.renderCompoundButton_unstable,
    renderMenuButton_unstable: ()=>_reactButton.renderMenuButton_unstable,
    renderSplitButton_unstable: ()=>_reactButton.renderSplitButton_unstable,
    renderToggleButton_unstable: ()=>_reactButton.renderToggleButton_unstable,
    splitButtonClassNames: ()=>_reactButton.splitButtonClassNames,
    toggleButtonClassNames: ()=>_reactButton.toggleButtonClassNames,
    useButton_unstable: ()=>_reactButton.useButton_unstable,
    useButtonStyles_unstable: ()=>_reactButton.useButtonStyles_unstable,
    useCompoundButton_unstable: ()=>_reactButton.useCompoundButton_unstable,
    useCompoundButtonStyles_unstable: ()=>_reactButton.useCompoundButtonStyles_unstable,
    useMenuButton_unstable: ()=>_reactButton.useMenuButton_unstable,
    useMenuButtonStyles_unstable: ()=>_reactButton.useMenuButtonStyles_unstable,
    useSplitButton_unstable: ()=>_reactButton.useSplitButton_unstable,
    useSplitButtonStyles_unstable: ()=>_reactButton.useSplitButtonStyles_unstable,
    useToggleButton_unstable: ()=>_reactButton.useToggleButton_unstable,
    useToggleButtonStyles_unstable: ()=>_reactButton.useToggleButtonStyles_unstable,
    useToggleState: ()=>_reactButton.useToggleState,
    Checkbox: ()=>_reactCheckbox.Checkbox,
    checkboxClassNames: ()=>_reactCheckbox.checkboxClassNames,
    renderCheckbox_unstable: ()=>_reactCheckbox.renderCheckbox_unstable,
    useCheckbox_unstable: ()=>_reactCheckbox.useCheckbox_unstable,
    useCheckboxStyles_unstable: ()=>_reactCheckbox.useCheckboxStyles_unstable,
    Combobox: ()=>_reactCombobox.Combobox,
    renderCombobox_unstable: ()=>_reactCombobox.renderCombobox_unstable,
    comboboxClassNames: ()=>_reactCombobox.comboboxClassNames,
    useComboboxStyles_unstable: ()=>_reactCombobox.useComboboxStyles_unstable,
    useCombobox_unstable: ()=>_reactCombobox.useCombobox_unstable,
    Dropdown: ()=>_reactCombobox.Dropdown,
    renderDropdown_unstable: ()=>_reactCombobox.renderDropdown_unstable,
    dropdownClassNames: ()=>_reactCombobox.dropdownClassNames,
    useDropdownStyles_unstable: ()=>_reactCombobox.useDropdownStyles_unstable,
    useDropdown_unstable: ()=>_reactCombobox.useDropdown_unstable,
    Listbox: ()=>_reactCombobox.Listbox,
    renderListbox_unstable: ()=>_reactCombobox.renderListbox_unstable,
    listboxClassNames: ()=>_reactCombobox.listboxClassNames,
    useListboxStyles_unstable: ()=>_reactCombobox.useListboxStyles_unstable,
    useListbox_unstable: ()=>_reactCombobox.useListbox_unstable,
    Option: ()=>_reactCombobox.Option,
    renderOption_unstable: ()=>_reactCombobox.renderOption_unstable,
    optionClassNames: ()=>_reactCombobox.optionClassNames,
    useOptionStyles_unstable: ()=>_reactCombobox.useOptionStyles_unstable,
    useOption_unstable: ()=>_reactCombobox.useOption_unstable,
    OptionGroup: ()=>_reactCombobox.OptionGroup,
    renderOptionGroup_unstable: ()=>_reactCombobox.renderOptionGroup_unstable,
    optionGroupClassNames: ()=>_reactCombobox.optionGroupClassNames,
    useOptionGroupStyles_unstable: ()=>_reactCombobox.useOptionGroupStyles_unstable,
    useOptionGroup_unstable: ()=>_reactCombobox.useOptionGroup_unstable,
    ComboboxProvider: ()=>_reactCombobox.ComboboxProvider,
    useComboboxContextValues: ()=>_reactCombobox.useComboboxContextValues,
    ListboxProvider: ()=>_reactCombobox.ListboxProvider,
    useListboxContextValues: ()=>_reactCombobox.useListboxContextValues,
    Divider: ()=>_reactDivider.Divider,
    dividerClassNames: ()=>_reactDivider.dividerClassNames,
    renderDivider_unstable: ()=>_reactDivider.renderDivider_unstable,
    useDivider_unstable: ()=>_reactDivider.useDivider_unstable,
    useDividerStyles_unstable: ()=>_reactDivider.useDividerStyles_unstable,
    Input: ()=>_reactInput.Input,
    inputClassNames: ()=>_reactInput.inputClassNames,
    renderInput_unstable: ()=>_reactInput.renderInput_unstable,
    useInput_unstable: ()=>_reactInput.useInput_unstable,
    useInputStyles_unstable: ()=>_reactInput.useInputStyles_unstable,
    Image: ()=>_reactImage.Image,
    imageClassNames: ()=>_reactImage.imageClassNames,
    renderImage_unstable: ()=>_reactImage.renderImage_unstable,
    useImage_unstable: ()=>_reactImage.useImage_unstable,
    useImageStyles_unstable: ()=>_reactImage.useImageStyles_unstable,
    Label: ()=>_reactLabel.Label,
    labelClassNames: ()=>_reactLabel.labelClassNames,
    renderLabel_unstable: ()=>_reactLabel.renderLabel_unstable,
    useLabel_unstable: ()=>_reactLabel.useLabel_unstable,
    useLabelStyles_unstable: ()=>_reactLabel.useLabelStyles_unstable,
    Link: ()=>_reactLink.Link,
    linkClassNames: ()=>_reactLink.linkClassNames,
    renderLink_unstable: ()=>_reactLink.renderLink_unstable,
    useLink_unstable: ()=>_reactLink.useLink_unstable,
    useLinkState_unstable: ()=>_reactLink.useLinkState_unstable,
    useLinkStyles_unstable: ()=>_reactLink.useLinkStyles_unstable,
    Menu: ()=>_reactMenu.Menu,
    MenuDivider: ()=>_reactMenu.MenuDivider,
    MenuGroup: ()=>_reactMenu.MenuGroup,
    MenuGroupContextProvider: ()=>_reactMenu.MenuGroupContextProvider,
    MenuGroupHeader: ()=>_reactMenu.MenuGroupHeader,
    MenuItem: ()=>_reactMenu.MenuItem,
    MenuItemCheckbox: ()=>_reactMenu.MenuItemCheckbox,
    MenuItemRadio: ()=>_reactMenu.MenuItemRadio,
    MenuList: ()=>_reactMenu.MenuList,
    MenuListProvider: ()=>_reactMenu.MenuListProvider,
    MenuPopover: ()=>_reactMenu.MenuPopover,
    MenuProvider: ()=>_reactMenu.MenuProvider,
    MenuSplitGroup: ()=>_reactMenu.MenuSplitGroup,
    MenuTrigger: ()=>_reactMenu.MenuTrigger,
    MenuTriggerContextProvider: ()=>_reactMenu.MenuTriggerContextProvider,
    menuDividerClassNames: ()=>_reactMenu.menuDividerClassNames,
    menuGroupClassNames: ()=>_reactMenu.menuGroupClassNames,
    menuGroupHeaderClassNames: ()=>_reactMenu.menuGroupHeaderClassNames,
    menuItemCheckboxClassNames: ()=>_reactMenu.menuItemCheckboxClassNames,
    menuItemClassNames: ()=>_reactMenu.menuItemClassNames,
    menuItemRadioClassNames: ()=>_reactMenu.menuItemRadioClassNames,
    menuListClassNames: ()=>_reactMenu.menuListClassNames,
    menuPopoverClassNames: ()=>_reactMenu.menuPopoverClassNames,
    menuSplitGroupClassNames: ()=>_reactMenu.menuSplitGroupClassNames,
    renderMenu_unstable: ()=>_reactMenu.renderMenu_unstable,
    renderMenuDivider_unstable: ()=>_reactMenu.renderMenuDivider_unstable,
    renderMenuGroup_unstable: ()=>_reactMenu.renderMenuGroup_unstable,
    renderMenuGroupHeader_unstable: ()=>_reactMenu.renderMenuGroupHeader_unstable,
    renderMenuItem_unstable: ()=>_reactMenu.renderMenuItem_unstable,
    renderMenuItemCheckbox_unstable: ()=>_reactMenu.renderMenuItemCheckbox_unstable,
    renderMenuItemRadio_unstable: ()=>_reactMenu.renderMenuItemRadio_unstable,
    renderMenuList_unstable: ()=>_reactMenu.renderMenuList_unstable,
    renderMenuPopover_unstable: ()=>_reactMenu.renderMenuPopover_unstable,
    renderMenuSplitGroup_unstable: ()=>_reactMenu.renderMenuSplitGroup_unstable,
    renderMenuTrigger_unstable: ()=>_reactMenu.renderMenuTrigger_unstable,
    useCheckmarkStyles_unstable: ()=>_reactMenu.useCheckmarkStyles_unstable,
    useMenu_unstable: ()=>_reactMenu.useMenu_unstable,
    useMenuContext_unstable: ()=>_reactMenu.useMenuContext_unstable,
    useMenuContextValues_unstable: ()=>_reactMenu.useMenuContextValues_unstable,
    useMenuDivider_unstable: ()=>_reactMenu.useMenuDivider_unstable,
    useMenuDividerStyles_unstable: ()=>_reactMenu.useMenuDividerStyles_unstable,
    useMenuGroup_unstable: ()=>_reactMenu.useMenuGroup_unstable,
    useMenuGroupContext_unstable: ()=>_reactMenu.useMenuGroupContext_unstable,
    useMenuGroupContextValues_unstable: ()=>_reactMenu.useMenuGroupContextValues_unstable,
    useMenuGroupHeader_unstable: ()=>_reactMenu.useMenuGroupHeader_unstable,
    useMenuGroupHeaderStyles_unstable: ()=>_reactMenu.useMenuGroupHeaderStyles_unstable,
    useMenuGroupStyles_unstable: ()=>_reactMenu.useMenuGroupStyles_unstable,
    useMenuItem_unstable: ()=>_reactMenu.useMenuItem_unstable,
    useMenuItemCheckbox_unstable: ()=>_reactMenu.useMenuItemCheckbox_unstable,
    useMenuItemCheckboxStyles_unstable: ()=>_reactMenu.useMenuItemCheckboxStyles_unstable,
    useMenuItemRadio_unstable: ()=>_reactMenu.useMenuItemRadio_unstable,
    useMenuItemRadioStyles_unstable: ()=>_reactMenu.useMenuItemRadioStyles_unstable,
    useMenuItemStyles_unstable: ()=>_reactMenu.useMenuItemStyles_unstable,
    useMenuList_unstable: ()=>_reactMenu.useMenuList_unstable,
    useMenuListContext_unstable: ()=>_reactMenu.useMenuListContext_unstable,
    useMenuListContextValues_unstable: ()=>_reactMenu.useMenuListContextValues_unstable,
    useMenuListStyles_unstable: ()=>_reactMenu.useMenuListStyles_unstable,
    useMenuPopover_unstable: ()=>_reactMenu.useMenuPopover_unstable,
    useMenuPopoverStyles_unstable: ()=>_reactMenu.useMenuPopoverStyles_unstable,
    useMenuSplitGroup_unstable: ()=>_reactMenu.useMenuSplitGroup_unstable,
    useMenuSplitGroupStyles_unstable: ()=>_reactMenu.useMenuSplitGroupStyles_unstable,
    useMenuTrigger_unstable: ()=>_reactMenu.useMenuTrigger_unstable,
    useMenuTriggerContext_unstable: ()=>_reactMenu.useMenuTriggerContext_unstable,
    Persona: ()=>_reactPersona.Persona,
    personaClassNames: ()=>_reactPersona.personaClassNames,
    renderPersona_unstable: ()=>_reactPersona.renderPersona_unstable,
    usePersonaStyles_unstable: ()=>_reactPersona.usePersonaStyles_unstable,
    usePersona_unstable: ()=>_reactPersona.usePersona_unstable,
    Popover: ()=>_reactPopover.Popover,
    PopoverSurface: ()=>_reactPopover.PopoverSurface,
    PopoverProvider: ()=>_reactPopover.PopoverProvider,
    PopoverTrigger: ()=>_reactPopover.PopoverTrigger,
    arrowHeights: ()=>_reactPopover.arrowHeights,
    popoverSurfaceClassNames: ()=>_reactPopover.popoverSurfaceClassNames,
    renderPopover_unstable: ()=>_reactPopover.renderPopover_unstable,
    renderPopoverSurface_unstable: ()=>_reactPopover.renderPopoverSurface_unstable,
    renderPopoverTrigger_unstable: ()=>_reactPopover.renderPopoverTrigger_unstable,
    usePopover_unstable: ()=>_reactPopover.usePopover_unstable,
    usePopoverContext_unstable: ()=>_reactPopover.usePopoverContext_unstable,
    usePopoverSurface_unstable: ()=>_reactPopover.usePopoverSurface_unstable,
    usePopoverSurfaceStyles_unstable: ()=>_reactPopover.usePopoverSurfaceStyles_unstable,
    usePopoverTrigger_unstable: ()=>_reactPopover.usePopoverTrigger_unstable,
    Portal: ()=>_reactPortal.Portal,
    usePortal_unstable: ()=>_reactPortal.usePortal_unstable,
    renderPortal_unstable: ()=>_reactPortal.renderPortal_unstable,
    Radio: ()=>_reactRadio.Radio,
    radioClassNames: ()=>_reactRadio.radioClassNames,
    RadioGroup: ()=>_reactRadio.RadioGroup,
    RadioGroupProvider: ()=>_reactRadio.RadioGroupProvider,
    radioGroupClassNames: ()=>_reactRadio.radioGroupClassNames,
    renderRadio_unstable: ()=>_reactRadio.renderRadio_unstable,
    renderRadioGroup_unstable: ()=>_reactRadio.renderRadioGroup_unstable,
    useRadio_unstable: ()=>_reactRadio.useRadio_unstable,
    useRadioGroupContext_unstable: ()=>_reactRadio.useRadioGroupContext_unstable,
    useRadioGroupContextValue_unstable: ()=>_reactRadio.useRadioGroupContextValue_unstable,
    useRadioGroupContextValues: ()=>_reactRadio.useRadioGroupContextValues,
    useRadioGroup_unstable: ()=>_reactRadio.useRadioGroup_unstable,
    useRadioGroupStyles_unstable: ()=>_reactRadio.useRadioGroupStyles_unstable,
    useRadioStyles_unstable: ()=>_reactRadio.useRadioStyles_unstable,
    Select: ()=>_reactSelect.Select,
    renderSelect_unstable: ()=>_reactSelect.renderSelect_unstable,
    selectClassNames: ()=>_reactSelect.selectClassNames,
    useSelectStyles_unstable: ()=>_reactSelect.useSelectStyles_unstable,
    useSelect_unstable: ()=>_reactSelect.useSelect_unstable,
    Slider: ()=>_reactSlider.Slider,
    sliderClassNames: ()=>_reactSlider.sliderClassNames,
    sliderCSSVars: ()=>_reactSlider.sliderCSSVars,
    useSliderState_unstable: ()=>_reactSlider.useSliderState_unstable,
    useSliderStyles_unstable: ()=>_reactSlider.useSliderStyles_unstable,
    useSlider_unstable: ()=>_reactSlider.useSlider_unstable,
    renderSlider_unstable: ()=>_reactSlider.renderSlider_unstable,
    SpinButton: ()=>_reactSpinbutton.SpinButton,
    renderSpinButton_unstable: ()=>_reactSpinbutton.renderSpinButton_unstable,
    spinButtonClassNames: ()=>_reactSpinbutton.spinButtonClassNames,
    useSpinButtonStyles_unstable: ()=>_reactSpinbutton.useSpinButtonStyles_unstable,
    useSpinButton_unstable: ()=>_reactSpinbutton.useSpinButton_unstable,
    Spinner: ()=>_reactSpinner.Spinner,
    spinnerClassNames: ()=>_reactSpinner.spinnerClassNames,
    renderSpinner_unstable: ()=>_reactSpinner.renderSpinner_unstable,
    useSpinner_unstable: ()=>_reactSpinner.useSpinner_unstable,
    useSpinnerStyles_unstable: ()=>_reactSpinner.useSpinnerStyles_unstable,
    Switch: ()=>_reactSwitch.Switch,
    switchClassNames: ()=>_reactSwitch.switchClassNames,
    renderSwitch_unstable: ()=>_reactSwitch.renderSwitch_unstable,
    useSwitch_unstable: ()=>_reactSwitch.useSwitch_unstable,
    useSwitchStyles_unstable: ()=>_reactSwitch.useSwitchStyles_unstable,
    renderTab_unstable: ()=>_reactTabs.renderTab_unstable,
    Tab: ()=>_reactTabs.Tab,
    tabClassNames: ()=>_reactTabs.tabClassNames,
    useTabStyles_unstable: ()=>_reactTabs.useTabStyles_unstable,
    useTab_unstable: ()=>_reactTabs.useTab_unstable,
    renderTabList_unstable: ()=>_reactTabs.renderTabList_unstable,
    TabList: ()=>_reactTabs.TabList,
    tabListClassNames: ()=>_reactTabs.tabListClassNames,
    TabListProvider: ()=>_reactTabs.TabListProvider,
    useTabListContext_unstable: ()=>_reactTabs.useTabListContext_unstable,
    useTabListContextValues_unstable: ()=>_reactTabs.useTabListContextValues_unstable,
    useTabListStyles_unstable: ()=>_reactTabs.useTabListStyles_unstable,
    useTabList_unstable: ()=>_reactTabs.useTabList_unstable,
    Body1: ()=>_reactText.Body1,
    Body1Strong: ()=>_reactText.Body1Strong,
    Body1Stronger: ()=>_reactText.Body1Stronger,
    Body2: ()=>_reactText.Body2,
    Caption1: ()=>_reactText.Caption1,
    Caption1Strong: ()=>_reactText.Caption1Strong,
    Caption1Stronger: ()=>_reactText.Caption1Stronger,
    Caption2: ()=>_reactText.Caption2,
    Caption2Strong: ()=>_reactText.Caption2Strong,
    Display: ()=>_reactText.Display,
    LargeTitle: ()=>_reactText.LargeTitle,
    Subtitle1: ()=>_reactText.Subtitle1,
    Subtitle2: ()=>_reactText.Subtitle2,
    Subtitle2Stronger: ()=>_reactText.Subtitle2Stronger,
    Text: ()=>_reactText.Text,
    Title1: ()=>_reactText.Title1,
    Title2: ()=>_reactText.Title2,
    Title3: ()=>_reactText.Title3,
    body1ClassNames: ()=>_reactText.body1ClassNames,
    body1StrongClassNames: ()=>_reactText.body1StrongClassNames,
    body1StrongerClassNames: ()=>_reactText.body1StrongerClassNames,
    body2ClassNames: ()=>_reactText.body2ClassNames,
    caption1ClassNames: ()=>_reactText.caption1ClassNames,
    caption1StrongClassNames: ()=>_reactText.caption1StrongClassNames,
    caption1StrongerClassNames: ()=>_reactText.caption1StrongerClassNames,
    caption2ClassNames: ()=>_reactText.caption2ClassNames,
    caption2StrongClassNames: ()=>_reactText.caption2StrongClassNames,
    displayClassNames: ()=>_reactText.displayClassNames,
    largeTitleClassNames: ()=>_reactText.largeTitleClassNames,
    subtitle1ClassNames: ()=>_reactText.subtitle1ClassNames,
    subtitle2ClassNames: ()=>_reactText.subtitle2ClassNames,
    subtitle2StrongerClassNames: ()=>_reactText.subtitle2StrongerClassNames,
    textClassNames: ()=>_reactText.textClassNames,
    title1ClassNames: ()=>_reactText.title1ClassNames,
    title2ClassNames: ()=>_reactText.title2ClassNames,
    title3ClassNames: ()=>_reactText.title3ClassNames,
    renderText_unstable: ()=>_reactText.renderText_unstable,
    useText_unstable: ()=>_reactText.useText_unstable,
    useTextStyles_unstable: ()=>_reactText.useTextStyles_unstable,
    Textarea: ()=>_reactTextarea.Textarea,
    textareaClassNames: ()=>_reactTextarea.textareaClassNames,
    renderTextarea_unstable: ()=>_reactTextarea.renderTextarea_unstable,
    useTextarea_unstable: ()=>_reactTextarea.useTextarea_unstable,
    useTextareaStyles_unstable: ()=>_reactTextarea.useTextareaStyles_unstable,
    Tooltip: ()=>_reactTooltip.Tooltip,
    renderTooltip_unstable: ()=>_reactTooltip.renderTooltip_unstable,
    tooltipClassNames: ()=>_reactTooltip.tooltipClassNames,
    useTooltip_unstable: ()=>_reactTooltip.useTooltip_unstable,
    useTooltipStyles_unstable: ()=>_reactTooltip.useTooltipStyles_unstable,
    Dialog: ()=>_reactDialog.Dialog,
    useDialog_unstable: ()=>_reactDialog.useDialog_unstable,
    renderDialog_unstable: ()=>_reactDialog.renderDialog_unstable,
    DialogTitle: ()=>_reactDialog.DialogTitle,
    dialogTitleClassNames: ()=>_reactDialog.dialogTitleClassNames,
    useDialogTitle_unstable: ()=>_reactDialog.useDialogTitle_unstable,
    useDialogTitleStyles_unstable: ()=>_reactDialog.useDialogTitleStyles_unstable,
    renderDialogTitle_unstable: ()=>_reactDialog.renderDialogTitle_unstable,
    DialogTrigger: ()=>_reactDialog.DialogTrigger,
    useDialogTrigger_unstable: ()=>_reactDialog.useDialogTrigger_unstable,
    renderDialogTrigger_unstable: ()=>_reactDialog.renderDialogTrigger_unstable,
    DialogBody: ()=>_reactDialog.DialogBody,
    dialogBodyClassNames: ()=>_reactDialog.dialogBodyClassNames,
    useDialogBody_unstable: ()=>_reactDialog.useDialogBody_unstable,
    useDialogBodyStyles_unstable: ()=>_reactDialog.useDialogBodyStyles_unstable,
    renderDialogBody_unstable: ()=>_reactDialog.renderDialogBody_unstable,
    DialogActions: ()=>_reactDialog.DialogActions,
    dialogActionsClassNames: ()=>_reactDialog.dialogActionsClassNames,
    useDialogActions_unstable: ()=>_reactDialog.useDialogActions_unstable,
    useDialogActionsStyles_unstable: ()=>_reactDialog.useDialogActionsStyles_unstable,
    renderDialogActions_unstable: ()=>_reactDialog.renderDialogActions_unstable,
    DialogSurface: ()=>_reactDialog.DialogSurface,
    dialogSurfaceClassNames: ()=>_reactDialog.dialogSurfaceClassNames,
    useDialogSurface_unstable: ()=>_reactDialog.useDialogSurface_unstable,
    useDialogSurfaceStyles_unstable: ()=>_reactDialog.useDialogSurfaceStyles_unstable,
    renderDialogSurface_unstable: ()=>_reactDialog.renderDialogSurface_unstable,
    DialogContent: ()=>_reactDialog.DialogContent,
    dialogContentClassNames: ()=>_reactDialog.dialogContentClassNames,
    useDialogContentStyles_unstable: ()=>_reactDialog.useDialogContentStyles_unstable,
    useDialogContent_unstable: ()=>_reactDialog.useDialogContent_unstable,
    renderDialogContent_unstable: ()=>_reactDialog.renderDialogContent_unstable,
    ProgressBar: ()=>_reactProgress.ProgressBar,
    progressBarClassNames: ()=>_reactProgress.progressBarClassNames,
    renderProgressBar_unstable: ()=>_reactProgress.renderProgressBar_unstable,
    useProgressBarStyles_unstable: ()=>_reactProgress.useProgressBarStyles_unstable,
    useProgressBar_unstable: ()=>_reactProgress.useProgressBar_unstable,
    Overflow: ()=>_reactOverflow.Overflow,
    OverflowItem: ()=>_reactOverflow.OverflowItem,
    useIsOverflowGroupVisible: ()=>_reactOverflow.useIsOverflowGroupVisible,
    useIsOverflowItemVisible: ()=>_reactOverflow.useIsOverflowItemVisible,
    useOverflowMenu: ()=>_reactOverflow.useOverflowMenu,
    DATA_OVERFLOWING: ()=>_reactOverflow.DATA_OVERFLOWING,
    DATA_OVERFLOW_MENU: ()=>_reactOverflow.DATA_OVERFLOW_MENU,
    DATA_OVERFLOW_ITEM: ()=>_reactOverflow.DATA_OVERFLOW_ITEM,
    Toolbar: ()=>_reactToolbar.Toolbar,
    ToolbarButton: ()=>_reactToolbar.ToolbarButton,
    useToolbarButtonStyles_unstable: ()=>_reactToolbar.useToolbarButtonStyles_unstable,
    useToolbarButton_unstable: ()=>_reactToolbar.useToolbarButton_unstable,
    ToolbarRadioButton: ()=>_reactToolbar.ToolbarRadioButton,
    useToolbarRadioButton_unstable: ()=>_reactToolbar.useToolbarRadioButton_unstable,
    useToolbarRadioButtonStyles_unstable: ()=>_reactToolbar.useToolbarRadioButtonStyles_unstable,
    ToolbarDivider: ()=>_reactToolbar.ToolbarDivider,
    useToolbarDivider_unstable: ()=>_reactToolbar.useToolbarDivider_unstable,
    ToolbarGroup: ()=>_reactToolbar.ToolbarGroup,
    useToolbarGroupStyles_unstable: ()=>_reactToolbar.useToolbarGroupStyles_unstable,
    useToolbarGroup_unstable: ()=>_reactToolbar.useToolbarGroup_unstable,
    renderToolbarGroup_unstable: ()=>_reactToolbar.renderToolbarGroup_unstable,
    toolbarGroupClassNames: ()=>_reactToolbar.toolbarGroupClassNames,
    ToolbarToggleButton: ()=>_reactToolbar.ToolbarToggleButton,
    useToolbarToggleButtonStyles_unstable: ()=>_reactToolbar.useToolbarToggleButtonStyles_unstable,
    useToolbarToggleButton_unstable: ()=>_reactToolbar.useToolbarToggleButton_unstable,
    renderToolbar_unstable: ()=>_reactToolbar.renderToolbar_unstable,
    toolbarClassNames: ()=>_reactToolbar.toolbarClassNames,
    useToolbar_unstable: ()=>_reactToolbar.useToolbar_unstable,
    useToolbarDividerStyles_unstable: ()=>_reactToolbar.useToolbarDividerStyles_unstable,
    useToolbarStyles_unstable: ()=>_reactToolbar.useToolbarStyles_unstable,
    ToolbarRadioGroup: ()=>_reactToolbar.ToolbarRadioGroup,
    TableCell: ()=>_reactTable.TableCell,
    tableCellClassNames: ()=>_reactTable.tableCellClassNames,
    tableCellClassName: ()=>_reactTable.tableCellClassName,
    useTableCellStyles_unstable: ()=>_reactTable.useTableCellStyles_unstable,
    useTableCell_unstable: ()=>_reactTable.useTableCell_unstable,
    renderTableCell_unstable: ()=>_reactTable.renderTableCell_unstable,
    TableRow: ()=>_reactTable.TableRow,
    tableRowClassNames: ()=>_reactTable.tableRowClassNames,
    tableRowClassName: ()=>_reactTable.tableRowClassName,
    useTableRowStyles_unstable: ()=>_reactTable.useTableRowStyles_unstable,
    useTableRow_unstable: ()=>_reactTable.useTableRow_unstable,
    renderTableRow_unstable: ()=>_reactTable.renderTableRow_unstable,
    TableBody: ()=>_reactTable.TableBody,
    tableBodyClassName: ()=>_reactTable.tableBodyClassName,
    tableBodyClassNames: ()=>_reactTable.tableBodyClassNames,
    useTableBodyStyles_unstable: ()=>_reactTable.useTableBodyStyles_unstable,
    useTableBody_unstable: ()=>_reactTable.useTableBody_unstable,
    renderTableBody_unstable: ()=>_reactTable.renderTableBody_unstable,
    Table: ()=>_reactTable.Table,
    tableClassName: ()=>_reactTable.tableClassName,
    tableClassNames: ()=>_reactTable.tableClassNames,
    useTableStyles_unstable: ()=>_reactTable.useTableStyles_unstable,
    useTable_unstable: ()=>_reactTable.useTable_unstable,
    renderTable_unstable: ()=>_reactTable.renderTable_unstable,
    TableHeader: ()=>_reactTable.TableHeader,
    tableHeaderClassNames: ()=>_reactTable.tableHeaderClassNames,
    tableHeaderClassName: ()=>_reactTable.tableHeaderClassName,
    useTableHeaderStyles_unstable: ()=>_reactTable.useTableHeaderStyles_unstable,
    useTableHeader_unstable: ()=>_reactTable.useTableHeader_unstable,
    renderTableHeader_unstable: ()=>_reactTable.renderTableHeader_unstable,
    TableHeaderCell: ()=>_reactTable.TableHeaderCell,
    tableHeaderCellClassName: ()=>_reactTable.tableHeaderCellClassName,
    tableHeaderCellClassNames: ()=>_reactTable.tableHeaderCellClassNames,
    useTableHeaderCellStyles_unstable: ()=>_reactTable.useTableHeaderCellStyles_unstable,
    useTableHeaderCell_unstable: ()=>_reactTable.useTableHeaderCell_unstable,
    renderTableHeaderCell_unstable: ()=>_reactTable.renderTableHeaderCell_unstable,
    TableResizeHandle: ()=>_reactTable.TableResizeHandle,
    tableResizeHandleClassNames: ()=>_reactTable.tableResizeHandleClassNames,
    useTableResizeHandleStyles_unstable: ()=>_reactTable.useTableResizeHandleStyles_unstable,
    useTableResizeHandle_unstable: ()=>_reactTable.useTableResizeHandle_unstable,
    renderTableResizeHandle_unstable: ()=>_reactTable.renderTableResizeHandle_unstable,
    TableContextProvider: ()=>_reactTable.TableContextProvider,
    useTableContext: ()=>_reactTable.useTableContext,
    TableSelectionCell: ()=>_reactTable.TableSelectionCell,
    useTableSelectionCellStyles_unstable: ()=>_reactTable.useTableSelectionCellStyles_unstable,
    useTableSelectionCell_unstable: ()=>_reactTable.useTableSelectionCell_unstable,
    renderTableSelectionCell_unstable: ()=>_reactTable.renderTableSelectionCell_unstable,
    tableSelectionCellClassNames: ()=>_reactTable.tableSelectionCellClassNames,
    TableCellActions: ()=>_reactTable.TableCellActions,
    useTableCellActionsStyles_unstable: ()=>_reactTable.useTableCellActionsStyles_unstable,
    useTableCellActions_unstable: ()=>_reactTable.useTableCellActions_unstable,
    renderTableCellActions_unstable: ()=>_reactTable.renderTableCellActions_unstable,
    tableCellActionsClassNames: ()=>_reactTable.tableCellActionsClassNames,
    TableCellLayout: ()=>_reactTable.TableCellLayout,
    useTableCellLayout_unstable: ()=>_reactTable.useTableCellLayout_unstable,
    useTableCellLayoutStyles_unstable: ()=>_reactTable.useTableCellLayoutStyles_unstable,
    renderTableCellLayout_unstable: ()=>_reactTable.renderTableCellLayout_unstable,
    tableCellLayoutClassNames: ()=>_reactTable.tableCellLayoutClassNames,
    useTableFeatures: ()=>_reactTable.useTableFeatures,
    useTableSelection: ()=>_reactTable.useTableSelection,
    useTableSort: ()=>_reactTable.useTableSort,
    createTableColumn: ()=>_reactTable.createTableColumn,
    DataGridCell: ()=>_reactTable.DataGridCell,
    dataGridCellClassNames: ()=>_reactTable.dataGridCellClassNames,
    useDataGridCellStyles_unstable: ()=>_reactTable.useDataGridCellStyles_unstable,
    useDataGridCell_unstable: ()=>_reactTable.useDataGridCell_unstable,
    renderDataGridCell_unstable: ()=>_reactTable.renderDataGridCell_unstable,
    DataGridRow: ()=>_reactTable.DataGridRow,
    dataGridRowClassNames: ()=>_reactTable.dataGridRowClassNames,
    useDataGridRowStyles_unstable: ()=>_reactTable.useDataGridRowStyles_unstable,
    useDataGridRow_unstable: ()=>_reactTable.useDataGridRow_unstable,
    renderDataGridRow_unstable: ()=>_reactTable.renderDataGridRow_unstable,
    DataGridBody: ()=>_reactTable.DataGridBody,
    dataGridBodyClassNames: ()=>_reactTable.dataGridBodyClassNames,
    useDataGridBodyStyles_unstable: ()=>_reactTable.useDataGridBodyStyles_unstable,
    useDataGridBody_unstable: ()=>_reactTable.useDataGridBody_unstable,
    renderDataGridBody_unstable: ()=>_reactTable.renderDataGridBody_unstable,
    DataGrid: ()=>_reactTable.DataGrid,
    dataGridClassNames: ()=>_reactTable.dataGridClassNames,
    useDataGridStyles_unstable: ()=>_reactTable.useDataGridStyles_unstable,
    useDataGrid_unstable: ()=>_reactTable.useDataGrid_unstable,
    renderDataGrid_unstable: ()=>_reactTable.renderDataGrid_unstable,
    useDataGridContextValues_unstable: ()=>_reactTable.useDataGridContextValues_unstable,
    DataGridHeader: ()=>_reactTable.DataGridHeader,
    dataGridHeaderClassNames: ()=>_reactTable.dataGridHeaderClassNames,
    useDataGridHeaderStyles_unstable: ()=>_reactTable.useDataGridHeaderStyles_unstable,
    useDataGridHeader_unstable: ()=>_reactTable.useDataGridHeader_unstable,
    renderDataGridHeader_unstable: ()=>_reactTable.renderDataGridHeader_unstable,
    DataGridHeaderCell: ()=>_reactTable.DataGridHeaderCell,
    dataGridHeaderCellClassNames: ()=>_reactTable.dataGridHeaderCellClassNames,
    useDataGridHeaderCellStyles_unstable: ()=>_reactTable.useDataGridHeaderCellStyles_unstable,
    useDataGridHeaderCell_unstable: ()=>_reactTable.useDataGridHeaderCell_unstable,
    renderDataGridHeaderCell_unstable: ()=>_reactTable.renderDataGridHeaderCell_unstable,
    DataGridSelectionCell: ()=>_reactTable.DataGridSelectionCell,
    useDataGridSelectionCellStyles_unstable: ()=>_reactTable.useDataGridSelectionCellStyles_unstable,
    useDataGridSelectionCell_unstable: ()=>_reactTable.useDataGridSelectionCell_unstable,
    renderDataGridSelectionCell_unstable: ()=>_reactTable.renderDataGridSelectionCell_unstable,
    dataGridSelectionCellClassNames: ()=>_reactTable.dataGridSelectionCellClassNames,
    TableRowIdContextProvider: ()=>_reactTable.TableRowIdContextProvider,
    useTableRowIdContext: ()=>_reactTable.useTableRowIdContext,
    useTableColumnSizing_unstable: ()=>_reactTable.useTableColumnSizing_unstable,
    Card: ()=>_reactCard.Card,
    CardFooter: ()=>_reactCard.CardFooter,
    CardHeader: ()=>_reactCard.CardHeader,
    CardPreview: ()=>_reactCard.CardPreview,
    cardClassNames: ()=>_reactCard.cardClassNames,
    cardCSSVars: ()=>_reactCard.cardCSSVars,
    cardFooterClassNames: ()=>_reactCard.cardFooterClassNames,
    cardHeaderClassNames: ()=>_reactCard.cardHeaderClassNames,
    cardHeaderCSSVars: ()=>_reactCard.cardHeaderCSSVars,
    cardPreviewClassNames: ()=>_reactCard.cardPreviewClassNames,
    renderCard_unstable: ()=>_reactCard.renderCard_unstable,
    renderCardFooter_unstable: ()=>_reactCard.renderCardFooter_unstable,
    renderCardHeader_unstable: ()=>_reactCard.renderCardHeader_unstable,
    renderCardPreview_unstable: ()=>_reactCard.renderCardPreview_unstable,
    useCard_unstable: ()=>_reactCard.useCard_unstable,
    useCardFooter_unstable: ()=>_reactCard.useCardFooter_unstable,
    useCardFooterStyles_unstable: ()=>_reactCard.useCardFooterStyles_unstable,
    useCardHeader_unstable: ()=>_reactCard.useCardHeader_unstable,
    useCardHeaderStyles_unstable: ()=>_reactCard.useCardHeaderStyles_unstable,
    useCardPreview_unstable: ()=>_reactCard.useCardPreview_unstable,
    useCardPreviewStyles_unstable: ()=>_reactCard.useCardPreviewStyles_unstable,
    useCardStyles_unstable: ()=>_reactCard.useCardStyles_unstable,
    Field: ()=>_reactField.Field,
    fieldClassNames: ()=>_reactField.fieldClassNames,
    FieldContextProvider: ()=>_reactField.FieldContextProvider,
    renderField_unstable: ()=>_reactField.renderField_unstable,
    useFieldContext_unstable: ()=>_reactField.useFieldContext_unstable,
    useFieldContextValues_unstable: ()=>_reactField.useFieldContextValues_unstable,
    useFieldControlProps_unstable: ()=>_reactField.useFieldControlProps_unstable,
    useFieldStyles_unstable: ()=>_reactField.useFieldStyles_unstable,
    useField_unstable: ()=>_reactField.useField_unstable
});
const _react = require("@griffel/react");
const _reactProvider = require("@fluentui/react-provider");
const _reactTabster = require("@fluentui/react-tabster");
const _reactTheme = require("@fluentui/react-theme");
const _reactSharedContexts = require("@fluentui/react-shared-contexts");
const _reactUtilities = require("@fluentui/react-utilities");
const _reactAccordion = require("@fluentui/react-accordion");
const _reactAvatar = require("@fluentui/react-avatar");
const _reactBadge = require("@fluentui/react-badge");
const _reactButton = require("@fluentui/react-button");
const _reactCheckbox = require("@fluentui/react-checkbox");
const _reactCombobox = require("@fluentui/react-combobox");
const _reactDivider = require("@fluentui/react-divider");
const _reactInput = require("@fluentui/react-input");
const _reactImage = require("@fluentui/react-image");
const _reactLabel = require("@fluentui/react-label");
const _reactLink = require("@fluentui/react-link");
const _reactMenu = require("@fluentui/react-menu");
const _reactPersona = require("@fluentui/react-persona");
const _reactPopover = require("@fluentui/react-popover");
const _reactPortal = require("@fluentui/react-portal");
const _reactRadio = require("@fluentui/react-radio");
const _reactSelect = require("@fluentui/react-select");
const _reactSlider = require("@fluentui/react-slider");
const _reactSpinbutton = require("@fluentui/react-spinbutton");
const _reactSpinner = require("@fluentui/react-spinner");
const _reactSwitch = require("@fluentui/react-switch");
const _reactTabs = require("@fluentui/react-tabs");
const _reactText = require("@fluentui/react-text");
const _reactTextarea = require("@fluentui/react-textarea");
const _reactTooltip = require("@fluentui/react-tooltip");
const _reactDialog = require("@fluentui/react-dialog");
const _reactProgress = require("@fluentui/react-progress");
const _reactOverflow = require("@fluentui/react-overflow");
const _reactToolbar = require("@fluentui/react-toolbar");
const _reactTable = require("@fluentui/react-table");
const _reactCard = require("@fluentui/react-card");
const _reactField = require("@fluentui/react-field");
 //# sourceMappingURL=index.js.map

//# sourceMappingURL=index.js.map